import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components'; // Importing the Logo and Newsletter components
import { contactContent } from '../../constants'; // Importing contact information and services data

// Importing necessary icons from react-icons
import { FaFacebookF, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import { GiCakeSlice } from 'react-icons/gi';

// Importing Link for navigation
import { Link } from 'react-router-dom';



// Find the "opening hours" object
const openingHoursData = contactContent.find(item => item.title === "opening hours");

// Get the content array
const timings = openingHoursData ? openingHoursData.content : [];

const Footer = () => {

  return (
    <footer className='footer'>

      <div className='box-container'>

        {/* About Section */}
        <div className='footer-item'>

          <Logo /> {/* Display the Logo component */}
          <p>Your Go-To Destination for Freshly Baked, Delightfully Sweet, and Made-to-Order Treats.</p> {/* Description for the about section */}

          {/* Newsletter component to subscribe */}
          <Newsletter />

        </div>

        {/* Useful Links Section */}
        <div className='footer-item'>
          <h2>Quick Links</h2>
          {/* Links for easy navigation to various pages */}
          <div className='info links'> 
            <p><GiCakeSlice className='icon' /><Link to='/About-us'>about Us</Link></p>
            <p><GiCakeSlice className='icon' /><Link to='/Custom-Orders'>Custom Orders</Link></p>
            <p><GiCakeSlice className='icon' /><Link to='/Portfolio'>Portfolio</Link></p>
            <p><GiCakeSlice className='icon' /><Link to='/Blog-grid'>Blogs</Link></p>
            <p><GiCakeSlice className='icon' /><Link to='/Shop-grid'>Shop</Link></p>
            <p><GiCakeSlice className='icon' /><Link to='/Contact-us'>contact</Link></p>
          </div>
        </div>

        {/* Opening Hours Info */}
        <div className="footer-item">
          <h2>opening hours</h2>
          <div className="timings">
            {timings.map((time, index) => {
              const [days, hours] = time.split(": ");
              return (
                <div className="timing-row" key={index}>
                  <p className="days">{days}</p>
                  <p className="hours">{hours}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Newsletter Section */}
        <div className='footer-item'>
          <h2>Contact Info</h2>
          <div className='info connect'>
            {contactContent
            .filter(contact => contact.id !== 4) // Exclude the contact with id: 4
            .map((contact) => (
                contact.content.map((value, index) => (
                  <div key={index} className='connect-item'>
                    <div className='icon'>{contact.icon}</div>
                    <span>{value}</span>
                  </div>
                ))
            ))}
          </div>
          {/* Social media icons with links */}
          <div className='social'>
            <a href="/#"><FaFacebookF className='icon' /></a>
            <a href="/#"><FaXTwitter className='icon' /></a>
            <a href="/#"><FaInstagram className='icon' /></a>
            <a href="/#"><FaLinkedin className='icon' /></a>
          </div>
        </div>

      </div>

      <div className='content'>

        {/* Footer content with copyright information */}
        <p>&copy; Sweet Delight 2025 All Rights Reserved</p>

      </div>

    </footer>
  )
}

export default Footer;